import React from "react";
import dynamic from "next/dynamic";
import Loader from "../../pixelmixer-webapp/src/component/loader/Loader";



const SiteAppNoSSR = dynamic(
  () => import("./SiteApp"),
  {
    ssr: false
  }
);

export default SiteAppNoSSR;
